<div hlmSidebarWrapper>
  <hlm-sidebar>
    <div hlmSidebarHeader>
      <h1 class="title-small-semibold text-content-neutral-primary flex">
        <a
          class="mr-sm"
          [routerLink]="['..']"
          hlmBtn
          size="icon"
          variant="ghost"
          aria-label="Retourner au tableau de bord"
          hlmTooltipTrigger="Retourner au tableau de bord"
        >
          <ng-icon hlm name="lucideArrowLeft" />
        </a>
        Le Compas
      </h1>
    </div>
    <div hlmSidebarContent>
      <div hlmSidebarGroup>
        <div hlmSidebarGroupContent>
          <ul hlmSidebarMenu>
            @for (item of _items(); track item.title) {
              <li hlmSidebarMenuItem>
                <a
                  #rla="routerLinkActive"
                  [routerLink]="[item.url]"
                  [isActive]="rla.isActive"
                  hlmSidebarMenuButton
                  routerLinkActive="active"
                >
                  <div class="mt-[2px]">
                    <ng-icon [name]="item.icon" hlm size="sm" />
                  </div>
                  <span>{{ item.title }}</span>
                </a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </hlm-sidebar>

  <div class="size-full">
    <router-outlet></router-outlet>
  </div>
</div>
